var modules_09e1f5ae = {"row":"Row_module_row__a4913684","sub-row":"Row_module_subRow__a4913684"};
import "../../../assets/esm/components/Table/src/Row~CqpRqM4R.css";

export { modules_09e1f5ae as default };
//# sourceMappingURL=Row.module.less.js.map
